import React from 'react'

function CardContent(props) {
  return (
    <>
      <li>
        <div className="flex">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-12 h-12 rounded-md ">
              <img
                alt="icons"
                src={`/img/icons/${props.logo}`}
                className="svg-yellow"
              />
            </div>
          </div>
          <div className="ml-4">
            <h4 className="text-lg font-medium text-white leading-6">
              {props.heading}
            </h4>
            <p className="mt-2 text-base leading-6 text-my-grey">
              {props.text}
            </p>
          </div>
        </div>
      </li>
    </>
  )
}

export default CardContent
